var Config = {
   LIMIT: "10",
   PERSIST_SECRET_KEY: "123456abcdef",
   ENVIRONMENT: "STAGING",
   ENVIRONMENTS: {
      LOCAL: {
         API_URL: "https://qa-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://qa-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://qa-configurator-tool.casita.kodefuse.com",
      },
      DEVELOPMENT: {
         API_URL: "https://qa-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://qa-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://qa-configurator-tool.casita.kodefuse.com",
      },
      STAGING: {
         API_URL: "https://qa-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://qa-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://qa-configurator-tool.casita.kodefuse.com",
      },
      DEMO: {
         API_URL: "https://qa-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://qa-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://qa-configurator-tool.casita.kodefuse.com",
      },
      PRODUCTION: {
         API_URL: "https://qa-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://qa-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://qa-configurator-tool.casita.kodefuse.com",
      },
   },
}

Config.env = () => {
   return Config.ENVIRONMENTS[Config.ENVIRONMENT]
}

export default Config